import { useState } from "react";
import classes from "./Homepage.module.css";
import EnterButton from "../icons/EnterButton";
import { NavLink } from "react-router-dom";
import db from "../articles.json";
import ArticlePost from "../components/Articles/ArticlePost";
import VideoButton from "../components/VideoButton/VideoButton";
import ModalVideo from "react-modal-video";
import YoutubePlayer from "../components/VideoCard/YoutubePlayer";
import clsx from "clsx";
import { Helmet } from "react-helmet";

interface HomepageCardInterface {
  to: string;
  title: string;
  text: string;
  url: string;
  bgimage: string;
}

const HomepageCard = ({
  to,
  title,
  text,
  url,
  bgimage,
}: HomepageCardInterface) => {
  const [modal, setModal] = useState(false);

  return (
    <>
      <div
        className={classes.homepageCard}
        style={{
          backgroundImage: `linear-gradient( rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8) ), url("/${bgimage}")`,
        }}
      >
        <div className={classes.homepageCardContents}>
          <NavLink to={to} style={{ textDecoration: "none" }}>
            <div className={classes.homepageCardInfo}>
              <h3 className={classes.homepageCardTitle}>{title}</h3>
              <p className={classes.homepageCardText}>{text}</p>
            </div>
          </NavLink>
          <div className={classes.homepageCardButtonWrapper}>
            <NavLink to={to}>
              <EnterButton text="Vstoupit" />
            </NavLink>
            <VideoButton white setModal={setModal} />
          </div>
        </div>
      </div>
      <ModalVideo
        channel="youtube"
        youtube={{ autoplay: 1, mute: 1 }}
        isOpen={modal}
        videoId={url}
        onClose={() => setModal(false)}
      />
    </>
  );
};

const Homepage = () => {
  const [playing, setPlaying] = useState(true);

  return (
    <div>
      <Helmet>
        <title>
          Portál pro autory sylabů a výukových materiálů, lektory a studenty
          českého znakového jazyka
        </title>
      </Helmet>
      <div className={classes.topSectionWrapper}>
        <div className={classes.topSectionContents}>
          <div className={classes.titleWrapper}>
            <YoutubePlayer
              playing={playing}
              setPlaying={setPlaying}
              controls
              url={"https://youtu.be/584UuVGHHuQ"}
              className={classes.video}
            />
            <h1 className={classes.homepageTitle}>
              Portál pro autory sylabů a výukových materiálů, lektory a studenty
              českého znakového jazyka
            </h1>
          </div>
        </div>
      </div>
      <div className={classes.sectionWrapper}>
        <h2
          style={{
            textAlign: "center",
            fontWeight: "700",
            fontSize: "48px",
            lineHeight: "125%",
            margin: "0",
          }}
        >
          Dokumenty
        </h2>
        <div className={classes.wrapper}>
          <HomepageCard
            url="dY5j1eztd5Q"
            bgimage="pictures/homepage_rrzj.jpg"
            to="/rrzj"
            title="Referenční rámec pro znakové jazyky (RRZJ)"
            text="RRZJ popisuje znalosti a dovednosti studenta znakového jazyka, avšak neodkazuje přitom na konkrétní znakový jazyk. Představuje teoretický základ pro vypracování popisů jednotlivých referenčních úrovní konkrétního znakového jazyka, v našem případě českého znakového jazyka. Je tedy základním podkladem pro dokument Popisy referenčních úrovní A1–B2 pro český znakový jazyk."
          />
          <HomepageCard
            url="CEX2bKf3nhA"
            bgimage="pictures/homepage_popisy.jpg"
            to="/popisy"
            title="Popisy referenčních úrovní A1–B2 pro český znakový jazyk (Popisy ČZJ)"
            text="Popisy ČZJ nahlíží na český znakový jazyk z funkčního i sémantického hlediska a jsou zpracovány pro referenční úrovně A1, A2, B1 a B2. Jejich cílem je poskytnout základní popis českého znakového jazyka a přispět ke zvyšování standardu výuky jako jazyka cizího, ke zkvalitnění tvorby sylabů či nastavení systému jazykových zkoušek."
          />
          <HomepageCard
            url="LnJ8at2gx8k"
            bgimage="pictures/homepage_glosar.jpg"
            to="/glosar"
            title="Glosář"
            text="Glosář obsahuje popis pojmů z RRZJ a Popisů referenčních úrovní A1–B2 pro český znakový jazyk. Slouží zejména k objasnění, jakým způsobem termíny chápou a používají autoři v rámci obou výše zmíněných sekcích."
          />
        </div>
      </div>

      <div className={classes.sectionWrapper}>
        <h2
          style={{
            textAlign: "center",
            fontWeight: "700",
            fontSize: "48px",
            lineHeight: "125%",
            margin: "0",
          }}
        >
          Články pro veřejnost
        </h2>
        <div className={classes.wrapper}>
          {db.slice(0, 3).map((item: any) => {
            return (
              <ArticlePost style={{ minWidth: "15rem" }} postsToRender={item} />
            );
          })}
        </div>
        <div className={classes.loadButton}>
          <NavLink
            style={{ color: "inherit", textDecoration: "none" }}
            to={"/proverejnost"}
          >
            Další články
          </NavLink>
        </div>
      </div>
      <div
        className={clsx(
          classes.sectionWrapper,
          classes.homepageFooter,
          classes.footerColumnsSection
        )}
      >
        <div className={classes.footerSection}>
          <div className={classes.footerCallout}>
            <p>
              Autorem materiálu a všech jeho částí, není-li uvedeno jinak, je
              kolektiv autorů NPI ČR (nástupnická organizace NÚV, projekt IPs
              APIV A v letech 2017 až 2022).
            </p>
          </div>
          <div className={classes.footerCallout}>
            <p>
              <a
                rel="license"
                href="http://creativecommons.org/licenses/by-sa/4.0/"
              >
                <img
                  alt="Licence Creative Commons"
                  style={{ borderWidth: 0 }}
                  src="https://i.creativecommons.org/l/by-sa/4.0/88x31.png"
                />
              </a>
              <br />
              Toto dílo podléhá licenci{" "}
              <a
                style={{ color: "white" }}
                rel="license"
                href="http://creativecommons.org/licenses/by-sa/4.0/"
              >
                Creative Commons Uveďte původ-Zachovejte licenci 4.0 Mezinárodní
                License
              </a>
              .
            </p>
          </div>
          <div className={classes.footerCallout}>
            <p>
              Piktogram „znakovat“ © 2018, jehož autorem je Deaf Friendly®,
              podléhá licenci{" "}
              <span style={{ whiteSpace: "nowrap" }}>CC BY-SA 4.0</span>.
            </p>
          </div>
          <div className={classes.footerCallout}>
            Kontaktní osoba: Tamara Kováčová,{" "}
            <a
              style={{ color: "white" }}
              href="mailto:tamara.kovacova@gmail.com"
            >
              tamara.kovacova@gmail.com
            </a>
          </div>
        </div>
        <div className={classes.footerSection}>
          <h3>Zpracoval kolektiv autorů NPI ČR</h3>
          <p>
            Mgr. Radka Nováková, PhDr. Romana Petráňová, Ph.D., Mgr. Lucie
            Štádlerová, Mgr. Marie Boccou Kestřánková, Ph.D., Milena Čiháková,
            Mgr. Martina Hulešová, Ph.D., M.A., Mgr. Denisa Lachmanová,
            Mgr. Jitka Schormová, Vladimír Šimon
          </p>

          <h3>Odborný oponent</h3>
          <p>Mgr. Petr Vysuček, Ph.D.</p>
          <h3>Odborné konzultace</h3>
          <p>prof. PhDr. Alena Macurová, CSc., PhDr. Klára Richterová</p>

          <h3>Recenzovali</h3>
          <p>
            Mgr. Lucie Kastnerová, Mgr. BcA. Pavel Kučera, Ph.D., Mgr. Jitka
            Sedláčková, Ph.D.
          </p>
          <h3>Kolektiv korektorů a editorů obsahu</h3>
          <p>
            PhDr. Anna Cíchová Hronová, Mgr. Radka Zbořilová, Mgr. Petra Slánská
            Bímová, Mgr. Jan Andrejsek, Mgr. Marie Komorná, Ph.D., Bc. Kristýna
            Špaček Pravdová, Mgr. Klára Herčíková, Bc. Josef Herz
          </p>

          <h3>Kolektiv překladatelů a tlumočníků</h3>
          <p>
            Mgr. Jitka Kubištová, Mgr. Michaela Dudková, Josef Sergej Bovkun,
            Mgr. Helena Andrejsková, Mgr. Barbora Fodorová, Bc. Zuzana Hájková,
            Mgr. Klára Herčíková, Mgr. Naďa Hynková Dingová, Ph.D., Mgr. Vendula
            Koutná, Mgr. Anna Kreslová, Bc. Dana Prellová, Bc. Hana Pešková,
            Mgr. Radka Stará, Mgr. Markéta Spilková, Pavlína Spilková,
            Bc. Markéta Šestáková, Bc. Veronika Tamchynová, Hana Wiesnerová
          </p>

          <h3>Kolektiv webu, natáčení a postprodukce videí</h3>
          <p>
            Mgr. Kateřina Lišková, Bc. Adam Chovanec, Jakub Goldmann, Ing. Lukáš
            Taclík, Marek Hecht, Bc. Josef Herz, Bc. Hana Buchtelová
          </p>

          <h3>Řízení a podpora klíčové aktivity</h3>
          <p>Mgr. Martin Kafka, Mgr. Tamara Kováčová, Mgr. Kateřina Trojková</p>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
